import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  ViewChild,
} from '@angular/core';
import { Popover, PopoverModule } from 'primeng/popover';
import { AvatarModule } from 'primeng/avatar';
import { SelectModule } from 'primeng/select';
import { StyleClassModule } from 'primeng/styleclass';
import {  ShortNamePipe } from '@fitness-force/pipes/short-name'
import { STAFFINTERFACE } from '@fitness-force/models';
import { StaffStoreService } from 'libs/api/src/lib/staff/staff-store.service';
@Component({
  selector: 'staff-info',
  templateUrl: './staff-info.component.html',
  styleUrls: ['./staff-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    AvatarModule,
    SelectModule,
    StyleClassModule,
    ShortNamePipe,
    PopoverModule
  ]
})
export class StaffInfoComponent implements OnInit {
  @Input() staffId=0;
  @Input() columnData=new BehaviorSubject(null);
  @Input() additionData=new BehaviorSubject(null);
  @Input() dataProperty="";

  @ViewChild('op') op: Popover;
  staffInfo:BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private store:Store,
    private staffStoreService: StaffStoreService
  ) {}

  ngOnInit(): void {
    if(this.staffId){
      this.loadStaff();
    }else{
      this.columnData.subscribe({next:(cData:any)=>{
        this.staffId = cData[this.dataProperty];
        this.loadStaff();
      }});
    }
  }

  loadStaff(){
    this.staffStoreService.getStaffById(this.staffId).subscribe((staff: STAFFINTERFACE) => {
      this.staffInfo.next(staff);
    });
    // this.store.pipe(
    //   select(STAFF_STATE),
    //   map((loaded) => {
    //     return loaded.staffListAll.filter((value) => value.id == this.staffId);
    //   }),
    //   mergeMap((value) => value)
    // ).subscribe({
    //   next: (staff:any) => {
    //     this.staffInfo.next(staff);
    //   },
    // });
  }
  toggleOverlay = (event:any) => this.op.toggle(event);
  show = (event:any) => this.op.show(event);
  hide = () => this.op.hide();
}